import { render, staticRenderFns } from "./PublicationSingleContent.vue?vue&type=template&id=27f452d6&"
import script from "./PublicationSingleContent.vue?vue&type=script&lang=js&"
export * from "./PublicationSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports